import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Overview from "./pages/Overview";
import Campaigns from "./pages/Campaigns";
import Timeline from "./pages/Timeline";
import TimelineCampanha from "./pages/TimelineCampanha";
import UTMs from "./pages/UTMs";
import Pending from "./pages/Pending";
import Alerts from "./pages/Alerts";
import History from "./pages/History";
import LeadsComercial from "./pages/LeadsComercial";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/timeline/:id" element={<TimelineCampanha />} />
          <Route path="/utms" element={<UTMs />} />
          <Route path="/leads-comercial" element={<LeadsComercial />} />
          <Route path="/pending" element={<Pending />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/history" element={<History />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
